<div class="loader-overlay">
  <mat-card>
    <label>Loading...</label>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped active"
        role="progressbar"
        style="width: 100%"
        aria-valuenow="100"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </mat-card>
</div>
